var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nft_allow"},[(!_vm.isSmall)?_c('button',{on:{"click":_vm.show}},[_c('fa',{attrs:{"icon":"eye"}}),_c('br'),_vm._v(" Show ")],1):_c('button',{on:{"click":_vm.show}},[_c('fa',{attrs:{"icon":"eye"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }